<template>
  <div
    :class="{
      beta: isBetaEnv && !$isElectron,
    }"
  >
    <AppHeader v-if="$isElectron && isMac" v-on:tag-clicked="clickTag" />
    <TestAnnouncement v-if="!$isElectron" />
    <!--<LaunchAppTop v-if="!$isElectron && $isMobile() && showOpenAppBtn" />-->
    <el-container v-bind:class="{ mobile: is_mobile, dark_mode: dark_mode, pc: !is_mobile }">
      <el-drawer
        v-if="is_mobile && drawerShow"
        :visible.sync="drawerShow"
        direction="ltr"
        :size="getWidth() * 0.8 > 300 ? '300px' : '80%'"
        :with-header="false"
      >
        <div class="aside-container" style="height: 100%; overflow-y: auto">
          <sidebar
            ref="sidebar"
            v-on:tag-clicked="clickTag"
            v-on:rename-tag-clicked="renameTagClicked"
            v-on:change-tag-icon-clicked="changeTagIconClick"
            v-on:closeSidebar="closeSidebar"
            style="padding: 0 10px"
          ></sidebar>
        </div>
      </el-drawer>
      <el-aside
        v-if="!is_mobile && !$route.query.hide_menu"
        class="left aside-container"
        :class="{
          hide: sidebarShow == 0,
          show: sidebarShow == 1,
        }"
      >
        <sidebar
          ref="sidebar"
          v-on:tag-clicked="clickTag"
          v-on:rename-tag-clicked="renameTagClicked"
          v-on:change-tag-icon-clicked="changeTagIconClick"
        ></sidebar>
      </el-aside>
      <!-- </transition> -->
      <transition name="slide-fade">
        <div
          class="fixed-side"
          v-if="showFixedSide"
          :style="{
            height: $isElectron ? windowHeight - 60 + 'px' : windowHeight - 40 + 'px',
          }"
        >
          <sidebar
            ref="sidebar"
            v-on:tag-clicked="clickTag"
            v-on:rename-tag-clicked="renameTagClicked"
            v-on:change-tag-icon-clicked="changeTagIconClick"
            v-on:hide-fixedSide="hideFixedSide"
          ></sidebar>
        </div>
      </transition>

      <el-main class="main-container">
        <memo-list
          v-if="
            !is_account &&
            !is_referral &&
            !is_membership &&
            !is_notify &&
            !is_lucky &&
            !is_incoming_webhook &&
            !is_redeem &&
            !is_notifications &&
            !is_recycle &&
            !is_stat &&
            !is_notion_sync &&
            !is_export &&
            !is_hotkey &&
            !is_tags &&
            !is_search
          "
          ref="memo_list"
          v-on:thread-clicked="openThread"
          v-on:tag-clicked="clickTag"
          v-on:tags-added="addTagNames"
          v-on:share-clicked="openShare"
          v-on:rename-tag-clicked="renameTagClicked"
          v-on:open-sidebar-clicked="openSidebar"
          v-on:change-tag-icon-clicked="changeTagIconClick"
          v-on:open-fold-memos="openFoldMemos"
          v-on:open-pinned-memos="openPinnedMemos"
          v-on:tag-clicked-by-search="clickTagBySearch"
        ></memo-list>
        <Account
          v-if="is_account"
          v-on:membership-clicked="clickMembership"
          v-on:notion-sync-clicked="clickNotionSync"
          v-on:open-sidebar-clicked="openSidebar"
          v-on:tag-clicked="clickTag"
          v-on:updatePasswordMode="updatePasswordMode"
        ></Account>
        <Referral v-if="is_referral" v-on:open-sidebar-clicked="openSidebar"></Referral>
        <AutoTags
          v-if="is_lucky"
          v-on:membership-clicked="clickMembership"
          v-on:open-sidebar-clicked="openSidebar"
        ></AutoTags>
        <Notify
          v-if="is_notify"
          v-on:membership-clicked="clickMembership"
          v-on:referral-clicked="clickReferral"
          v-on:wechat-clicked="clickWechat"
          v-on:open-sidebar-clicked="openSidebar"
          v-on:share-clicked="openShare"
          v-on:thread-clicked="openThread"
          v-on:tag-clicked="clickTag"
          v-on:tags-added="addTagNames"
        ></Notify>
        <IncomingWebhook
          v-if="is_incoming_webhook"
          v-on:membership-clicked="clickMembership"
          v-on:open-sidebar-clicked="openSidebar"
        ></IncomingWebhook>
        <Redeem v-if="is_redeem" v-on:open-sidebar-clicked="openSidebar"></Redeem>
        <Notifications v-if="is_notifications" v-on:open-sidebar-clicked="openSidebar"></Notifications>
        <Recycle v-if="is_recycle" v-on:open-sidebar-clicked="openSidebar"></Recycle>
        <NotionSync
          v-if="is_notion_sync"
          v-on:membership-clicked="clickMembership"
          v-on:open-sidebar-clicked="openSidebar"
        ></NotionSync>
        <RecordStat v-if="is_stat" v-on:open-sidebar-clicked="openSidebar" v-on:tag-clicked="clickTag"> </RecordStat>
        <ExportMemoVue v-if="is_export" />
        <NewMembershipVue
          v-if="is_membership"
          v-on:referral-clicked="clickReferral"
          v-on:open-sidebar-clicked="openSidebar"
        />
        <Hotkey v-if="is_hotkey" v-on:referral-clicked="clickReferral" v-on:open-sidebar-clicked="openSidebar" />
        <AllTags
          v-if="is_tags"
          v-on:referral-clicked="clickReferral"
          v-on:open-sidebar-clicked="openSidebar"
          v-on:change-tag-icon-clicked="changeTagIconClick"
          v-on:rename-tag-clicked="renameTagClicked"
        ></AllTags>
        <SearchPage
          v-if="is_search"
          v-on:tag-clicked="clickTag"
          v-on:referral-clicked="clickReferral"
          v-on:open-sidebar-clicked="openSidebar"
          v-on:thread-clicked="openThread"
          v-on:tags-added="addTagNames"
          v-on:share-clicked="openShare"
          v-on:open-fold-memos="openFoldMemos"
          v-on:open-pinned-memos="openPinnedMemos"
        />
      </el-main>

      <el-dialog
        :title="$t('web_app.tag_rename')"
        :visible.sync="tagRenameVisible"
        :width="is_mobile ? '80%' : '300px'"
        :close-on-click-modal="false"
        v-if="tagRenameVisible"
      >
        <div style="text-align: right; margin: 0">
          <el-input v-model="new_tag_name" style="margin-bottom: 6px" />
          <el-button type="text" @click="tagRenameVisible = false">{{ $t('web_app.tag_rename_cancel') }}</el-button>
          <el-button type="primary" @click="renameTag" :disabled="is_rename_running ? true : false">{{
            is_rename_running ? $t('components.TagTree.messages.dialog_submit_hint') : $t('web_app.tag_rename')
          }}</el-button>
        </div>
      </el-dialog>
      <TagIcon ref="tagIcon" :tag_position="tag_position" v-on:tag-clicked="clickTag"></TagIcon>
      <RenameTagVue ref="renameTag"></RenameTagVue>
      <DownloadPrompt v-if="!is_mobile" />
      <el-dialog
        :visible.sync="foldMemoListShow"
        size="100%"
        :with-header="false"
        :destroy-on-close="true"
        fullscreen
        :show-close="false"
        custom-class="memoModal"
      >
        <FoldMemoList
          ref="foldMemoList"
          v-on:close-clicked="closeFoldMemos"
          v-on:memo-removed="removeMemo"
          v-on:new-reply-created="newReplyCreated"
          v-on:tag-clicked="clickTag"
          v-on:thread-clicked="openThread"
          v-on:share-clicked="openShare"
          v-on:membership-clicked="clickMembership"
          v-on:add-linked-memo="addLinkedMemo"
          style="padding: 0 10px"
        ></FoldMemoList>
        <div class="proTip" v-if="!is_pro">
          <div class="proTipContent">
            {{ $t('foldMemoList.detail.proTipContent') }} <svg-icon iconClass="pro"></svg-icon>
            {{ $t('foldMemoList.detail.proTipContent2') }}
          </div>
          <div class="proTipBtn" @click="upgrade">{{ $t('foldMemoList.detail.proTipBtn') }}</div>
        </div>
      </el-dialog>
      <NewHomeNotice
        v-if="!is_mobile && !is_notify"
        v-on:share-clicked="openShare"
        v-on:memo-removed="removeMemo"
        v-on:tag-clicked="clickTag"
        v-on:thread-clicked="openThread"
        v-on:add-linked-memo="addLinkedMemo"
      />
      <FullScreenEditor />
      <heatgridDialogVue />
    </el-container>
    <el-dialog
      :visible.sync="threadShow"
      size="100%"
      :with-header="false"
      :destroy-on-close="true"
      fullscreen
      :show-close="false"
      custom-class="memoModal"
    >
      <thread
        ref="thread"
        v-on:close-clicked="closeThread"
        v-on:memo-removed="removeMemo"
        v-on:new-reply-created="newReplyCreated"
        v-on:tag-clicked="clickTag"
        v-on:thread-clicked="openThread"
        v-on:share-clicked="openShare"
        v-on:membership-clicked="clickMembership"
        v-on:add-linked-memo="addLinkedMemo"
        v-if="(!present_marking_modal && !showAiIcon) || (!present_marking_modal && showAiIcon && is_mobile)"
      />

      <Annotation v-else ref="annotation" v-on:close-clicked="closeThread" style="padding: 0 10px" />
    </el-dialog>
    <LockScreenVue ref="lockScreen" />
    <MemoShare v-if="shareVisible" ref="memoShare" v-on:membership-clicked="clickMembership" />
    <MemoDetail
      ref="thread"
      v-on:close-clicked="closeThread"
      v-on:memo-removed="removeMemo"
      v-on:new-reply-created="newReplyCreated"
      v-on:tag-clicked="clickTag"
      v-on:thread-clicked="openThread"
      v-on:share-clicked="openShare"
      v-on:membership-clicked="clickMembership"
      v-on:add-linked-memo="addLinkedMemo"
      v-if="!is_mobile && showAiIcon"
    />
    <AppUpdateTip v-if="$isElectron" />
    <AppUpdateModal v-if="$isElectron" />
    <LaunchAppBottom v-if="!$isElectron && $isMobile() && !is_membership && showOpenAppBtn" />
  </div>
</template>
<script>
//import Sidebar from '../pages/Sidebar.vue'
import MemoList from '../pages/MemoList.vue'
import Thread from '../pages/Thread.vue'
import TagIcon from '../components/TagIcon.vue'

//import Account from '../pages/Account.vue'
//import AutoTags from '../pages/AutoTags.vue'
//import Referral from '../pages/Referral.vue'
//import Notify from '../pages/Notify.vue'
//import Redeem from '../pages/Redeem.vue'
//import IncomingWebhook from '../pages/IncomingWebhook.vue'
//import Notifications from '../pages/Notifications.vue'
//import Recycle from '../pages/Recycle.vue'
//import NotionSync from '../pages/NotionSync.vue'
import DBUtil from '../utils/DBUtil'
//import RenameTagVue from '@/components/RenameTag.vue'
//import RecordStat from '../pages/RecordStat'
//import ExportMemoVue from '../pages/ExportMemo.vue'
//import Hotkey from '../pages/Hotkey.vue'

//import LockScreenVue from '@/components/LockScreen.vue'
//import NewMembershipVue from '../pages/NewMembership.vue'
//import AppHeader from '../components/AppHeader.vue'
import { throttle, getOsType, isBetaEnv } from '../utils/utils'
import emitter from '../utils/eventbus.js'
//import DownloadPrompt from '../components/DownloadPrompt.vue'
//import FoldMemoList from '../components/FoldMemoList.vue'
//import TestAnnouncement from '../components/TestAnnouncement.vue'
import { getKeyCode } from '../utils/keyCode'
import logPageView from '../utils/logPageView'
//import Annotation from '../components/Annotation.vue'
//import FullScreenEditor from '../components/FullScreenEditor.vue'
//import NewHomeNotice from '../components/HomeNotice/New.vue'
//import LaunchAppTop from '../components/LaunchAppTop.vue'
import Ipc from '../plugin/ipc'
//import heatgridDialogVue from '../components/onboarding/dialogs/heatgrid.vue'
import logClickEvent from '@utils/logClickEvent'
//import MemoShare from '../components/MemoShare'
import WXOpenApp from '../plugin/wxOpenApp'
import { isAiAllowHost } from '@utils/aiLimit'

export default {
  components: {
    Sidebar: () => import('../pages/Sidebar.vue'),
    MemoList,
    Thread,
    TagIcon,
    Account: () => import('../pages/Account.vue'),
    AutoTags: () => import('../pages/AutoTags.vue'),
    Referral: () => import('../pages/Referral.vue'),
    Notify: () => import('../pages/Notify.vue'),
    Redeem: () => import('../pages/Redeem.vue'),
    IncomingWebhook: () => import('../pages/IncomingWebhook.vue'),
    Notifications: () => import('../pages/Notifications.vue'),
    Recycle: () => import('../pages/Recycle.vue'),
    NotionSync: () => import('../pages/NotionSync.vue'),
    RenameTagVue: () => import('@/components/RenameTag.vue'),
    LockScreenVue: () => import('@/components/LockScreen.vue'),
    RecordStat: () => import('../pages/RecordStat'),
    ExportMemoVue: () => import('../pages/ExportMemo.vue'),
    NewMembershipVue: () => import('../pages/NewMembership.vue'),
    Hotkey: () => import('../pages/Hotkey.vue'),
    AppHeader: () => import('../components/Desktop/AppHeader.vue'),
    DownloadPrompt: () => import('../components/DownloadPrompt.vue'),
    FoldMemoList: () => import('../components/FoldMemoList.vue'),
    TestAnnouncement: () => import('../components/TestAnnouncement.vue'),
    Annotation: () => import('../components/Annotation.vue'),
    FullScreenEditor: () => import('../components/FullScreenEditor.vue'),
    NewHomeNotice: () => import('../components/HomeNotice/New.vue'),
    //LaunchAppTop: () => import('../components/LaunchAppTop.vue'),
    heatgridDialogVue: () => import('../components/onboarding/dialogs/heatgrid.vue'),
    MemoShare: () => import('../components/MemoShare'),
    MemoDetail: () => import('../components/MemoDetail'),
    SearchPage: () => import('../pages/Search/index.vue'),
    AppUpdateModal: () => import('../components/Desktop/AppUpdateModal'),
    AppUpdateTip: () => import('../components/Desktop/AppUpdateTip'),
    LaunchAppBottom: () => import('../components/LaunchAppBottom.vue'),
  },
  data() {
    return {
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640,
      drawerShow: false, // mobile，左侧边栏
      threadShow: false,
      shareVisible: false,
      tagRenameVisible: false,
      old_tag_name: null,
      new_tag_name: null,
      tag_position: {
        clientX: 0,
        clientY: 0,
      },
      loading: false,
      is_rename_running: false,
      showHelp: !process.env.IS_ELECTRON,
      showFixedSide: false,
      isHover: false,
      user: this.$store.state.me,
      isMac: getOsType() == 'mac',
      foldMemoListShow: false,
      isBetaEnv: isBetaEnv(),
      timer: null,
      present_marking_modal: false,
      showOpenAppBtn: false,
    }
  },
  computed: {
    showAiIcon() {
      const { use_llm } = this.$store.state.me
      return isAiAllowHost() && use_llm
    },
    // eslint-disable-next-line vue/return-in-computed-property
    dark_mode() {
      if (this.$store.state.theme == 'auto') {
        // follow system setting
        const darkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)')
        return darkMode && darkMode.matches
      }
      return this.$store.state.theme == 'dark'
    },
    selected_tag() {
      return this.$store.state.selected_tag
    },
    pinned_selected_tag() {
      return this.$store.state.pinned_selected_tag
    },
    selected_source() {
      return this.$store.state.selected_source
    },
    start_date() {
      return this.$store.state.start_date
    },
    end_date() {
      return this.$store.state.end_date
    },
    type() {
      // notag, link
      return this.$store.state.type
    },
    is_account() {
      return this.selected_source == 'account'
    },
    is_referral() {
      return this.selected_source == 'referral'
    },
    is_lucky() {
      return this.selected_source == 'lucky'
    },
    is_membership() {
      return this.selected_source == 'membership'
    },
    is_notify() {
      return this.selected_source == 'notify'
    },
    is_redeem() {
      return this.selected_source == 'redeem'
    },
    is_incoming_webhook() {
      return this.selected_source == 'incoming_webhook'
    },
    is_notifications() {
      return this.selected_source == 'notifications'
    },
    is_recycle() {
      return this.selected_source == 'recycle'
    },
    is_stat() {
      return this.selected_source == 'stat'
    },
    is_notion_sync() {
      return this.selected_source == 'notion_sync'
    },
    is_export() {
      return this.selected_source == 'export'
    },
    sidebarShow() {
      return this.$store.state.sidebarShow
    },
    fixedSidebarShow() {
      return this.$store.state.fixedSidebarShow
    },
    windowHeight() {
      return window.innerHeight
    },
    is_hotkey() {
      return this.selected_source == 'hotkey'
    },
    is_pro() {
      return this.$store.getters.is_pro
    },
    is_tags() {
      return this.selected_source == 'tags'
    },
    membership_referral() {
      return this.$store.state.membership_referral
    },
    is_wechat() {
      return this.selected_source == 'wechat'
    },
    in_wechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent)
    },
    is_search() {
      return this.selected_source == 'search'
    },
  },
  methods: {
    initVConsole() {
      this.$store.state.me.id == 634 && new VConsole()
    },
    openPinnedMemos(slug) {
      this.openFoldMemos(slug)
    },
    upgrade() {
      this.foldMemoListShow = false
      setTimeout(() => {
        this.$store.commit('setSelectedSource', 'membership')
        this.clickTag('from=pin_memo')
      }, 300)
    },
    openFoldMemos(slug) {
      this.foldMemoListShow = true
      if (this.$refs.foldMemoList) {
        this.$refs.foldMemoList.loading = true
        this.$refs.foldMemoList.loadMemos(slug)
      } else {
        setTimeout(() => {
          this.openFoldMemos(slug)
        }, 500)
      }
    },
    closeFoldMemos() {
      this.foldMemoListShow = false
      this.$refs.memo_list.loadMemos()
      // 包含搜索内容则不修改地址
      // if (
      //   window.location.href.indexOf('query') == -1 ||
      //   !this.type ||
      //   !this.selected_tag ||
      //   !this.selected_source ||
      //   !this.start_date ||
      //   !this.end_date
      // ) {
      //   this.clickTag()
      // }
    },
    clickTag(val) {
      let url = window.location.origin + '/mine?'
      if (this.$isElectron) {
        url = window.location.origin + '/#/mine?'
      }
      if (this.selected_tag != null) {
        url = url + 'tag=' + encodeURIComponent(this.selected_tag) + '&'
      }
      if (this.pinned_selected_tag != null) {
        url = url + 'tag=' + encodeURIComponent(this.pinned_selected_tag) + '&pin=1&'
      }
      if (this.selected_source) {
        url = url + 'source=' + this.selected_source + '&'
      }
      if (this.start_date) {
        url = url + 'start_date=' + this.start_date + '&'
      }
      if (this.end_date) {
        url = url + 'end_date=' + this.end_date + '&'
      }
      if (this.type) {
        url = url + 'type=' + this.type + '&'
      }
      let membership_referral = ''
      if (val) {
        url = url + val + '&'
        membership_referral = val.replace('from=', '')
      }
      const { hide_menu } = this.$route.query

      if (hide_menu) {
        url = url + 'hide_menu=1&'
      }

      logPageView(this.selected_source, val ? membership_referral : '')
      url = url.substr(0, url.length - 1) // 去掉最后一个 ? 或 &
      window.history.pushState(null, null, url ? url : '?')

      if (this.$store.state.isOpenMemo) {
        return false
      }
      //this.$store.state.query = null

      if (
        (this.$refs.memo_list && !this.selected_source) ||
        (this.$refs.memo_list && this.selected_source == 'wechat')
      ) {
        // document.querySelector('.memos').scrollTop = 0
        this.$refs.memo_list.query = null
        this.$refs.memo_list.keyword = null
        this.$refs.memo_list.loading = true
        this.$refs.memo_list.end = false
        this.$refs.memo_list.memos = []
        this.$refs.memo_list.pinnedMemos = []
        this.$refs.memo_list.advancedSearchQuery = null // 高级搜索查询
        this.$refs.memo_list.showAdvancedSearch = false
        this.$refs.memo_list.advancedSearch()
      }

      this.drawerShow = false
    },
    clickTagBySearch(val) {
      console.log(val, this.selected_tag)
      let url = window.location.origin + '/mine?'
      if (this.$isElectron) {
        url = window.location.origin + '/#/mine?'
      }
      if (this.selected_tag != null) {
        url = url + 'tag=' + encodeURIComponent(this.selected_tag) + '&'
      }
      if (this.pinned_selected_tag != null) {
        url = url + 'tag=' + encodeURIComponent(this.pinned_selected_tag) + '&pin=1&'
      }
      if (this.selected_source) {
        url = url + 'source=' + this.selected_source + '&'
      }
      if (this.start_date) {
        url = url + 'start_date=' + this.start_date + '&'
      }
      if (this.end_date) {
        url = url + 'end_date=' + this.end_date + '&'
      }
      if (this.type) {
        url = url + 'type=' + this.type + '&'
      }
      let membership_referral = ''
      if (val) {
        url = url + val + '&'
        membership_referral = val.replace('from=', '')
      }
      const { hide_menu } = this.$route.query

      if (hide_menu) {
        url = url + 'hide_menu=1&'
      }

      logPageView(this.selected_source, val ? membership_referral : '')
      url = url.substr(0, url.length - 1) // 去掉最后一个 ? 或 &
      window.history.pushState(null, null, url ? url : '?')

      if (this.$store.state.isOpenMemo) {
        return false
      }
      this.$store.state.query = null

      if (
        (this.$refs.memo_list && !this.selected_source) ||
        (this.$refs.memo_list && this.selected_source == 'wechat')
      ) {
        // document.querySelector('.memos').scrollTop = 0
        this.$refs.memo_list.query = null
        this.$refs.memo_list.keyword = null
        this.$refs.memo_list.loading = true
        this.$refs.memo_list.memos = []
        this.$refs.memo_list.advancedSearchQuery = null // 高级搜索查询
        this.$refs.memo_list.showAdvancedSearch = false
        this.$refs.memo_list.loadMemos()
      }

      this.drawerShow = false
    },
    openSidebar() {
      this.drawerShow = true
    },
    closeSidebar() {
      this.drawerShow = false
    },
    openThread(memo_id, http_direct = false, showRecommentMemos = false) {
      if (!memo_id) {
        return
      }
      if (!this.showAiIcon || (this.showAiIcon && this.is_mobile)) {
        this.threadShow = true
      }

      this.threadMemoId = memo_id
      this.$store.commit('setIsOpenMemo', true)

      if (this.$refs.thread) {
        this.$refs.thread.loadMemo(memo_id, http_direct, showRecommentMemos)
      } else {
        setTimeout(() => {
          this.openThread(memo_id, http_direct, showRecommentMemos)
        }, 500)
      }
    },
    closeThread() {
      this.$store.commit('setIsOpenMemo', false)
      this.threadShow = false
      this.threadMemoId = null
      this.present_marking_modal = false
      // 包含搜索内容则不修改地址
      // if (
      //   window.location.href.indexOf('query') == -1 ||
      //   !this.type ||
      //   !this.selected_tag ||
      //   !this.selected_source ||
      //   !this.start_date ||
      //   !this.end_date
      // ) {
      //   this.clickTag()
      // }
    },
    removeMemo(memo) {
      this.$refs.memo_list.removeMemo(memo)
    },
    newReplyCreated(newReply) {
      this.$refs.memo_list.newReplyCreated(newReply)
    },
    addTagNames(tag_names) {
      this.$store.commit('addLatestTagNames', tag_names)
      this.$store.commit('addTagNames', tag_names)
    },
    openShare(memo) {
      this.shareVisible = true
      if (this.$refs.memoShare) {
        this.$refs.memoShare.openDialog(memo)
      } else {
        setTimeout(() => {
          this.openShare(memo)
        }, 500)
      }
    },
    /* OTHER PAGES BEGIN */
    async resetFilter() {
      await this.$store.dispatch('resetFilter')
    },
    clickMembership(val) {
      if (this.is_mobile) {
        window.open('/mine?source=membership&' + val, '_self')
      } else {
        this.resetFilter()
        this.$store.commit('setSelectedSource', 'membership')
        this.clickTag(val)
      }
    },
    clickNotionSync() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'notion_sync')
      this.clickTag()
    },
    clickReferral(val) {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'referral')
      this.clickTag(val)
    },
    clickWechat() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'wechat')
      this.clickTag()
    },
    clickStat() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'stat')
      this.clickTag()
    },
    /* OTHER PAGES END */
    /* Rename Tag START */
    renameTagClicked(tag_position, tag_name, isTree, level, parentNodeWidth) {
      this.old_tag_name = tag_name
      this.new_tag_name = tag_name
      // this.tagRenameVisible = true
      this.$refs.renameTag.show(tag_position, tag_name, isTree, level, parentNodeWidth)
    },
    renameTag() {
      // 判断 tag_name 是否包含#
      if (this.new_tag_name.indexOf('#') > -1) {
        this.$message.error(this.$t('components.TagTree.messages.rename_tag_tips'))
        return
      }
      if (this.new_tag_name == this.old_tag_name || this.is_rename_running) {
        this.tagRenameVisible = false
        return // 没有改名，不用后续处理
      }

      this.is_rename_running = true
      this.$message.success(this.$t('components.TagTree.messages.waiting'))

      let vm = this
      DBUtil.renameTag(this.old_tag_name, this.new_tag_name).then((result, error_message) => {
        vm.tagRenameVisible = false
        vm.is_rename_running = false
        if (result) {
          vm.$store.commit('setSelectedTag', vm.new_tag_name)
          vm.clickTag()
          // 重加载标签(延时是为了等 ES 数据同步) => 现在是本地操作 不需要等待了
          // setTimeout(() => {
          // 	vm.$store.dispatch("loadTags");
          // }, 2000);

          // 重加载置顶标签
          vm.$store.dispatch('loadPinnedTags')
        } else {
          vm.$message.error(vm.$t('components.TagTree.messages.reject'))
        }
      })

      // vm.$http
      // 	.post("/api/tag/rename", {
      // 		old_tag: vm.old_tag_name,
      // 		new_tag: vm.new_tag_name,
      // 	})
      // 	.then((response) => {
      // 		if (response.data && response.data.code === -1) {
      // 			vm.$message.error(response.data.message);
      // 		} else if (response.data && response.data.code === 0) {
      // 			// 重加载 memo
      // 			vm.$store.commit("setSelectedTag", vm.new_tag_name);
      // 			vm.clickTag();

      // 			// 重加载标签(延时是为了等 ES 数据同步)
      // 			setTimeout(() => {
      // 				vm.$store.dispatch("loadTags");
      // 			}, 2000);

      // 			// 重加载置顶标签
      // 			vm.$store.dispatch("loadPinnedTags");
      // 		}
      // 	});
    },
    /* Rename Tag END */
    addLinkedMemo(_memo) {
      if (!this.selected_source) {
        this.closeThread()
        this.$refs.memo_list.addLinkedMemo(_memo)
      } else {
        this.present_marking_modal = true
        this.$nextTick(() => {
          this.$refs.annotation.addLinkedMemo(_memo)
        })
      }
    },
    /* changeTagIconClick */
    changeTagIconClick(value, tag_name, type) {
      this.$refs.tagIcon.show(value, tag_name, type)
    },
    clickWithBody(e) {
      if (this.$refs.tagIcon) {
        this.$refs.tagIcon.show({
          clientY: 0,
        })
      }
    },
    // 获取设备width
    getWidth() {
      return document.documentElement.clientWidth
    },
    updatePasswordMode() {
      this.$refs.lockScreen.init()
    },
    updatePosition(e) {
      const FIXED_SIDE_DELAY = 1000
      if (this.sidebarShow == '1' || this.isHover) {
        return
      }
      const mainContainer = document.querySelector('.main-container')
      const { x, y } = e
      const maxY = this.windowHeight - 20
      const offsetLeft = mainContainer.offsetLeft

      if (offsetLeft < 220) {
        if (x < offsetLeft - 10) {
          if (this.timer) {
            return
          }
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.toggleFixedSideBar(true)
          }, FIXED_SIDE_DELAY)
        } else {
          this.toggleFixedSideBar(false)
          clearTimeout(this.timer)
          this.timer = null
        }
      } else {
        if (x > 220 || y > maxY) {
          this.toggleFixedSideBar(false)
          clearTimeout(this.timer)
          this.timer = null
        } else {
          if (this.timer) {
            return
          }
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.toggleFixedSideBar(true)
          }, FIXED_SIDE_DELAY)
        }
      }
    },
    toggleFixedSideBar(show) {
      this.showFixedSide = show
    },
    hideFixedSide() {
      this.showFixedSide = false
    },
    getRect(el) {
      return el.getBoundingClientRect()
    },
    flip(firstEl, getLastEl = () => firstEl) {
      const firstRect = this.getRect(firstEl)
      requestAnimationFrame(() => {
        // Last
        let lastEl = getLastEl()
        const lastRect = this.getRect(lastEl)
        lastEl.animate(
          [
            {
              transform: `
          translateX(${firstRect.left - lastRect.left}px)
        `,
            },
            {
              transform: `
          translateX(0)
         `,
            },
          ],
          {
            duration: 600,
            easing: 'cubic-bezier(0.2, 0, 0.2, 1)',
          },
        )
      })
    },

    handleFlip() {
      this.flip(document.querySelector('.main-container'))
    },
    handleHotkey(e) {
      const hotKeys = this.$store.state.hotkeys

      // 提取热键匹配逻辑
      const matchHotKey = (hot) => {
        const { ctrlKey, shiftKey, altKey, key, code, metaKey, keyCode } = e
        const controlKey = [metaKey && 'Meta', ctrlKey && 'Ctrl', shiftKey && 'Shift', altKey && 'Alt']
          .filter(Boolean)
          .join('+')

        if (key) {
          return controlKey + '+' + getKeyCode(keyCode) === hot.key
        }

        return controlKey === hot.key
      }

      const hotKeyActions = {
        edit: () => {
          if (!this.selected_source) {
            emitter.emit('editFocus')
          }
        },
        password: () => {
          if (!this.$store.getters.is_pro) {
            this.$message({
              type: 'info',
              message: this.$t('pages.Account.password_mode.info'),
            })
            return
          }
          this.$store.commit('setLock', 1)
        },
        search: () => {
          if (!this.selected_source || this.selected_source === 'search' || this.selected_source === 'wechat') {
            emitter.emit('searchMemo')
          }
        },
        toggleSidebar: () => {
          this.$store.commit('setSidebarShow', this.sidebarShow === '1' ? 0 : 1)
          this.showFixedSide = false
        },
        home: () => {
          if (this.selected_source || this.selected_tag) {
            this.resetFilter()
            this.clickTag()
          }
        },
        reload: () => {
          // 刷新页面
          if (this.$isElectron) {
            return
          }
          window.location.reload()
        },
      }

      hotKeys.forEach((hot) => {
        if (matchHotKey(hot) && hotKeyActions[hot.action]) {
          hotKeyActions[hot.action]()
          e.preventDefault()
          e.stopPropagation()
        }
      })
    },

    clickHotKey() {
      this.$store.commit('setSelectedSource', 'hotkey')
      this.$emit('tag-clicked')
    },

    setThemeColor() {
      const themeColor = document.querySelector('[name=theme-color]')
      if (this.dark_mode) {
        document.getElementsByTagName('body')[0].className = 'dark_mode'
        document.documentElement.setAttribute('data-theme', 'dark')
        if (themeColor) {
          themeColor.setAttribute('content', '#252729')
        }
      } else {
        document.body.removeAttribute('class', 'dark_mode')
        document.documentElement.setAttribute('data-theme', 'light')
        if (themeColor) {
          themeColor.setAttribute('content', '#fafafa')
        }
      }
    },
    async getUserInfo() {
      return new Promise((resolve) => {
        this.$api.call('GET', '/user/me', {}, (response) => {
          if (response.data && response.data.code === 0) {
            this.$store.commit('setMe', response.data.data)
            const lang = response.data.data.language.slice(0, 2)
            this.$i18n.locale = lang
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    clickEvent(e) {
      // a click event
      if (e.target.tagName === 'A') {
        e.preventDefault()

        const href = e.target.getAttribute('data-href') || e.target.getAttribute('href') || ''
        const isInnerMemoLink = e.target.classList.contains('inner_memo_link')
        const isBlankMemoLink = e.target.classList.contains('blank_memo_link')

        if (!href || isInnerMemoLink) {
          return
        }
        if (isBlankMemoLink) {
          logClickEvent('MEMO卡片', isInnerMemoLink ? '点击批注' : '点击链接')
        }
        const FLIMO_HOST = 'https://v.flomoapp.com'
        const isExternalLink = href.indexOf('http') === 0
        const finalHref = isExternalLink ? href : FLIMO_HOST + href
        const isMAS = window.isMAS != undefined && window.isMAS
        if (this.$isElectron || isMAS) {
          window.ipcRenderer.send('openUrl', finalHref)
        } else {
          window.open(finalHref, '_blank')
        }
      }
    },
    imgError(e) {
      // img preview 图片加载失败
      if (this.$store.state.me && this.$store.state.me.language) {
        const language = this.$store.state.me.language.toLowerCase().slice(0, 2)
        if (e.target.tagName == 'IMG' && e.target.className == 'el-image-viewer__img') {
          e.target.src = `/img/img-${language}-err.png`
        }
      } else {
        if (e.target.tagName == 'IMG' && e.target.className == 'el-image-viewer__img') {
          e.target.src = `/img/img-zh-err.png`
        }
      }
    },

    loadThreadMemo(http_direct) {
      if (this.threadShow && this.threadMemoId) {
        if (this.$refs.thread) {
          this.$refs.thread.loadMemo(this.threadMemoId, http_direct)
        } else {
          setTimeout(() => {
            this.openThread(this.threadMemoId, http_direct)
          }, 500)
        }
      }
    },
  },
  async created() {
    this.setThemeColor()
    // addListener a click event
    document.addEventListener('click', this.clickEvent, false)
    // 监听图片加载失败
    document.addEventListener('error', this.imgError, true)
    if (this.$isElectron) {
      app.ipc = new Ipc(this)
      app.ipc.init()
    }

    if (this.$route.query.source) {
      this.$store.commit('setSelectedSource', this.$route.query.source)
    }
    if (this.$route.query.start_date) {
      this.$store.commit('setStartDate', this.$route.query.start_date)
    }
    if (this.$route.query.end_date) {
      this.$store.commit('setEndDate', this.$route.query.end_date)
    }
    if (this.$route.query.type) {
      this.$store.commit('setType', this.$route.query.type)
    }

    if (this.$route.query.token) {
      if (!this.$store.state.me) {
        const me = {
          access_token: this.$route.query.token,
        }
        this.$store.commit('setMe', me)
      }
      const url = window.location.href
      const newUrl = url.replace(/(\?|&)token=[^&]+/, '')
      window.history.pushState(null, null, newUrl)
    } else {
      if (!this.$store.state.me) {
        localStorage.setItem('redirect_path_after_login', this.$route.fullPath)
        this.$router.replace({ name: 'login' })
        return
      }
    }

    await this.getUserInfo()

    await this.$store.dispatch('loadStat')

    // 获取微信 jssdk 签名
    if (this.in_wechat) {
      const wx = WXOpenApp.getInstance()
      wx.init(() => {
        this.showOpenAppBtn = true
      })
    } else {
      this.showOpenAppBtn = true
    }
    if (this.$route.query.memo_id) {
      this.openThread(this.$route.query.memo_id, true)
    } else {
      await this.$store.dispatch('loadTags')
      await this.$store.dispatch('loadLatestTags')
      await this.$store.dispatch('loadPinnedTags')
      await this.$store.dispatch('loadWechatInfo')
      await this.$store.dispatch('loadUserSettings')
    }

    window.addEventListener('click', this.clickWithBody)
    // 监听按键事件
    window.addEventListener(
      'keydown',
      (e) => {
        // 如果是tab键
        if (e.key === 'Tab') {
          // 在不在ProseMirror中
          if (e.target.className.indexOf('ProseMirror') > -1) {
            // 有没有list-item
            if (!e.target.parentElement.querySelector('li')) {
              e.preventDefault()
            }
          }
        }
      },
      true,
    )

    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.is_mobile = this.$isMobile() || document.body.clientWidth <= 640
      //throttle(this.loadThreadMemo(false), 1000)
    })
    const { from, api_key } = this.$route.query

    logPageView(this.selected_source, from ? from : api_key ? api_key : '')
    // 监听 aside-container 滚动
    // const ASIDE_CONTAINER_SELECTOR = '.aside-container'
    // const SCROLL_TOP_POSITION = 0

    // const asideContainer = document.querySelector(ASIDE_CONTAINER_SELECTOR)
    // asideContainer?.addEventListener('scroll', () => {
    //   this.$refs.tagIcon?.show({ clientY: SCROLL_TOP_POSITION })
    // })
  },
  mounted() {
    // 监听鼠标移动
    document.addEventListener('mousemove', throttle(this.updatePosition, 100))
    if (!this.$isMobile()) {
      // 移动端屏蔽快捷键
      window.addEventListener('keydown', this.handleHotkey)
    }
    emitter.on('showFixedSide', () => {
      this.isHover = true
      this.showFixedSide = true
    })
    emitter.on('hideFixedSide', () => {
      this.showFixedSide = false
      this.isHover = false
    })

    emitter.on('sync-finish', () => {
      setTimeout(() => {
        this.$store.dispatch('loadStat')
      }, 3000)
    })

    emitter.on('open-memo', (data) => {
      this.openThread(data)
    })
  },

  beforeDestroy() {
    window.removeEventListener('click', this.clickWithBody)
    document.removeEventListener('mousemove', this.updatePosition)
    document.removeEventListener('keydown', this.handleHotkey)
    if (app.ipc) {
      app.ipc.destroyed()
    }
  },
  watch: {
    '$store.state.sidebarShow': function (val) {
      this.handleFlip()
    },
  },
}
</script>
<style scoped>
/*@import '/public/css/dark_mode.css';*/
.el-container {
  width: min-content;
  max-width: 100%;
  height: calc(100vh);
  margin: 0 auto;
}

.desktop .el-container {
  height: calc(100vh - 50px);
}

.beta .el-container {
  height: calc(100vh - 40px);
}
.el-container.mobile {
  width: 100%;
}

.el-main {
  width: 640px !important;
}
.el-aside.right {
  width: 270px !important;
}
@media screen and (max-width: 640px) {
  .el-aside.left {
    display: none;
  }
}
@media screen and (max-width: 880px) {
  .el-aside.right {
    display: none;
  }
}
.el-main {
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.el-drawer__wrapper /deep/ .el-drawer {
  /* max-width: 90%; */
  height: 100%;
}
.el-drawer__wrapper /deep/ .el-drawer__body {
  overflow: auto;
  background: #fafafa;
}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 20px 10px;
}

.el-drawer__wrapper /deep/ .el-drawer__body .flomo-fade {
  display: none;
}

.help-link {
  display: block;
  line-height: 2;
}

.el-dialog__wrapper /deep/ .el-dialog.share-memo-dialog {
  background: var(--memoShareCardBg);
}
.el-dialog__wrapper /deep/ .el-dialog.share-dialog .el-dialog__body {
  padding: 0 0 0px 0;
}

.hide {
  transition: all 0.8s ease;
  transform: translateX(-100vw);
  position: fixed;
}

.show {
  transition: all 0.5s ease;
  transform: translateX(0);
}

.fixed-side {
  position: fixed;
  left: 0;
  top: 20px;
  box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.15);
  border-radius: 0px 6px 6px 0px;
  width: 220px;
  overflow-y: scroll;
  display: block;
  z-index: 999;
  background: var(--bodyBg);
  padding: 0 10px;
}

.desktop .fixed-side {
  top: 38px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-hide-enter-active {
  transition: all 0.3s ease;
}
.slide-hide-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-hide-enter,
.slide-hide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

/* .slide-fade-enter {
  animation: fadeInLeft 1s;
}

.slide-fade-leave-to {
  animation: fadeOutLeft 1s;
} */

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@-webkit-keyframes fadeOutLeft {
  0% {
    opacity: 1;
    -webkit-transform: translateX(0);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateX(-20px);
  }
}
@keyframes fadeOutLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-20px);
  }
}
.proTip {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 14px;
  text-align: justify;
  color: var(--textSecondary);
}
.proTip .proTipContent {
  display: flex;
  align-items: center;
}

.proTip .proTipContent svg {
  margin: 0 5px;
}
.proTip .proTipBtn {
  color: rgba(87, 131, 247, 1);
  cursor: pointer;
}
</style>

<style>
@media screen and (max-width: 750px) {
  .confirm {
    width: 80% !important;
  }
}
.memoModal {
  background: var(--noticeListItemBg) !important;
}

.memoModal .el-dialog__header {
  display: none !important;
}

.memoModal .el-dialog__body {
  padding: 0 !important;
}

@media screen and (max-width: 1000px) {
  .el-aside {
    padding: 0 20px;
  }
  .el-aside.left {
    width: 280px !important;
  }
}

@media screen and (min-width: 1000px) {
  .el-aside.left {
    width: 260px !important;
  }
}

.placeholder-div {
  height: 30px;
}

.desktop .el-drawer__body .header {
  padding-top: 30px;
}

.el-tooltip__popper.is-dark {
  color: #efefef !important;
}
</style>
